import React from 'react'
import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Theme } from '@mui/material/styles'

interface ITextImageProps {
  layout?: 'leftImage' | 'rightImage'
  imagePath: string
  content?: string
  headline3?: string
  headline1?: string
  headline2?: string

}
const TextImage: React.FC<ITextImageProps> = (props) => {
  const theme: Theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <>
      <Stack
        direction={{ xs: 'column-reverse', md: props.layout === 'leftImage' ? 'row' : 'row-reverse' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        style={{display: "flex",alignItems: "center"}}>
     
        <img style={{ margin: downMd ? `${theme.spacing(3)} 0` : `${theme.spacing(3)} ${theme.spacing(2)}`, maxWidth: downMd ? '100%' : '50%', height: 'auto' }} src={props.imagePath} />
        <Box>
          {props.headline1 &&
            <Typography variant='h1'>{props.headline1}</Typography>}
          {props.headline2 &&
            <Typography variant='h2'>{props.headline2}</Typography>}
          {props.headline3 &&
            <Typography variant='h3'>{props.headline3}</Typography>}
          {props.content &&
            <Typography variant='body1'>{props.content}</Typography>}
        </Box>
      </Stack>
    </>
  )
}
export default TextImage
